import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import PropTypes from 'prop-types';

import Stack from '@zenbusiness/zui/Stack';
import { useTheme } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

function Estimate({ estimate }) {
  const theme = useTheme();

  if (!estimate) {
    return null;
  }

  return (
    <Stack gap={1} horizontal>
      <ArrowForwardRoundedIcon color={theme.palette.text.secondary} sx={{ fontSize: 24 }} />
      <Text size="sm">{estimate}</Text>
    </Stack>
  );
}

Estimate.propTypes = {
  estimate: PropTypes.string
};

export default Estimate;
